import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import ApiServices from "../../../Services/ApiServices/ApiServices";

const ReferalSourcesAdd = ({ onClose, onSuccess }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    zip_code: "",
    company: "",
    department: "",
    position: "",
    password: "",
    bank_details: {
      account_number: "",
      routing_number: "",
      bank_name: "",
    },
  });

  const handleChange = (field, value) => {
    if (field.startsWith("bank_")) {
      setForm({
        ...form,
        bank_details: {
          ...form.bank_details,
          [field.replace("bank_", "")]: value,
        },
      });
    } else {
      setForm({ ...form, [field]: value });
    }
  };

  const handleSubmit = async () => {
    try {
      await ApiServices.post(
        "/referral-sources/register/",
        form
      );
      onSuccess("Referral source added successfully");
    } catch {
      onSuccess("Failed to add referral source", "error");
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {[
          "name",
          "email",
          "phone",
          "address",
          "zip_code",
          "company",
          "department",
          "position",
          "password",
        ].map((f) => (
          <Grid item xs={12} md={6} key={f}>
            <TextField
              fullWidth
              label={f.replace("_", " ").toUpperCase()}
              type={f === "password" ? "password" : "text"}
              onChange={(e) => handleChange(f, e.target.value)}
            />
          </Grid>
        ))}

        {["account_number", "routing_number", "bank_name"].map((f) => (
          <Grid item xs={12} md={6} key={f}>
            <TextField
              fullWidth
              label={f.replace("_", " ").toUpperCase()}
              onChange={(e) =>
                handleChange(`bank_${f}`, e.target.value)
              }
            />
          </Grid>
        ))}
      </Grid>

      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ReferalSourcesAdd;
